import { useEffect, useRef, useState } from "react";
import copy from "copy-to-clipboard";
import {
  ButtonFinish,
  CodeAuthContainer,
  CodeAuthSecret,
  CodeAuthText,
  ContainerErrors,
  ContainerModel,
  ContainerQRCodeImage,
  ContainerSecretCodeText,
  ContentContainerModel,
  EnteredCode,
  FormTextAuthCode,
  LoadingSecretText,
  QRCodeImage,
  StepsAuthCode,
  StepsAuthScanCode,
  TextMessageCode,
  TitleModel,
} from "./AddQRCodeModelStyles.styled";
import useAuth from "../../../../Redux/useAuth";
import { useQRCode } from "../../../../API/QRCode/QRCode";
import { useQRCodeCheck } from "../../../../API/QRCode/QRCodeCheck";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Languages/Langs/LanguageContext";

interface ValidationQRCodeProps {
  onClose: () => void;
}

export const AddQRCodeModel: React.FC<ValidationQRCodeProps> = ({
  onClose,
}) => {
  const { t } = useLanguageContext();
  const { tokenAccount, idUser } = useAuth();
  const textRef = useRef<HTMLSpanElement>(null);
  const { qrCode } = useQRCode(tokenAccount);
  const { validateQRCode, error, isValid } = useQRCodeCheck(
    tokenAccount,
    idUser || null,
  );

  const copyToClipboard = () => {
    if (!qrCode?.secretCode) return;

    const isCopy = copy(qrCode.secretCode);

    if (isCopy) {
      toast.success("Copied to Clipboard");
    }
  };

  const [checkORCode, setCheckQRCode] = useState<string>("");

  const filled = !!checkORCode.trim();

  const checkQRCOdeForm = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();

    await validateQRCode(checkORCode);
  };

  useEffect(() => {
    if (isValid) {
      // якщо код успішний → закрити модалку після 1 сек
      const t = setTimeout(() => onClose(), 1000);
      return () => clearTimeout(t);
    }
  }, [isValid, onClose]);

  return (
    <>
      <ContainerModel>
        <ContentContainerModel>
          <TitleModel>{t("privateTraslate.Models.AddQRCodeTitle")}</TitleModel>
          <ContainerQRCodeImage>
            {qrCode ? (
              <>
                <QRCodeImage src={qrCode.qrCode} alt="QR Code" />
                <StepsAuthScanCode>
                  {t("privateTraslate.Models.AddQRCodeStepsAuthScanCode")}
                </StepsAuthScanCode>
              </>
            ) : (
              <p>Loading QR code...</p>
            )}
          </ContainerQRCodeImage>

          <ContainerSecretCodeText>
            {qrCode ? (
              <>
                <CodeAuthContainer>
                  <CodeAuthText>
                    {t("privateTraslate.Models.AddQRCodeAuthText")}
                  </CodeAuthText>
                  <CodeAuthSecret ref={textRef} onClick={copyToClipboard}>
                    {qrCode.secretCode}
                  </CodeAuthSecret>
                </CodeAuthContainer>
                <StepsAuthCode>
                  {t("privateTraslate.Models.AddQRCodeStepsAuthCode")}
                </StepsAuthCode>
              </>
            ) : (
              // add animation
              <LoadingSecretText>Loading secret</LoadingSecretText>
            )}
          </ContainerSecretCodeText>

          <TextMessageCode>
            {t("privateTraslate.Models.AddQRCodeTextMessageCode")}
          </TextMessageCode>
          <FormTextAuthCode onSubmit={checkQRCOdeForm}>
            <EnteredCode
              type="text"
              placeholder={t("privateTraslate.Models.AddQRCodeEnteredCode")}
              value={checkORCode ?? ""}
              onChange={(e) => setCheckQRCode(e.target.value)}
            />
            <ContainerErrors>
              {error && <span style={{ color: "red" }}>{error}</span>}
              {isValid && (
                <p style={{ color: "green" }}>
                  ✅ {t("privateTraslate.Models.AddQRCodeValid")}
                </p>
              )}
            </ContainerErrors>

            <ButtonFinish
              type="submit"
              value={t("privateTraslate.Models.AddQRCodeButtonFinish")}
              $filled={filled}
              disabled={!filled}
            />
          </FormTextAuthCode>
        </ContentContainerModel>
      </ContainerModel>
    </>
  );
};
